// AuthContext.js - Updated to handle tokens
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { env } from '../constants/env';
import { getTokenExpirationTime } from '../utilities/functions';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Set base URL for axios
  const apiClient = axios.create({
    baseURL: env.apiUrl, // Base URL set to localhost
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    const checkAuth = async () => {
      // Get token from localStorage
      
      if (!token) {
        setLoading(false);
        return;
      }

      apiClient.defaults.headers['Authorization'] = `Bearer ${token}`; // Set Authorization header

      try {
        const response = await apiClient.get('/api/auth/me');
        console.log("CHECK TOKEN", response.data)
        setUser(response.data.user);
      } catch (error) {
        console.error('Failed to check auth:', error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      const expirationTime = getTokenExpirationTime(token);

      if (expirationTime) {
        const currentTime = Date.now();
        const timeUntilExpiry = expirationTime - currentTime;

        // If token has already expired, logout immediately
        // if (timeUntilExpiry <= 0) {
        //   logout();
        // } else {
        //   // Set timeout to logout when token expires
        //   setTimeout(logout, timeUntilExpiry);
        // }
      }
    }

    checkAuth();
  }, []);

  // Login function
  const login = async (email, password) => {
    // console.log("SENDING", { email, password })
    const response = await apiClient.post('/api/auth/signin/admin', { email, password });
    
    localStorage.setItem('token', response.data.token); // Store token in localStorage
    setUser(response.data.user);
    return response.data.user
  };

  // Logout function
  const logout = () => {
    setUser(null);
    localStorage.removeItem('token'); // Remove token from localStorage
    navigate('/login');
  };
  

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};